export class ValidateAccessPolicyResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "valid",
            "baseName": "valid",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "issues",
            "baseName": "issues",
            "type": "Array<DataCatalogValidationIssue>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ValidateAccessPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
